// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "portfolio" + "." + "30ef5d1d" + ".js";
};